import { useEffect } from 'react';
// src/pages/About.jsx
export function About() {
    useEffect(() => {
        // Очищаем стейты при первом рендере страницы
        return () => {
            // Здесь код очистки (например, setList([]), setData(null))
        };
    }, []);

    const containerStyle = {
        width: '300px',            // Ширина контейнера
        height: '150px',           // Высота контейнера
        backgroundColor: '#3498db',// Цвет фона (синий)
        color: '#ffffff',          // Цвет текста (белый)
        borderRadius: '8px',       // Скругленные углы
        display: 'flex',           // Flexbox для выравнивания
        justifyContent: 'center',  // Выравнивание по горизонтали
        alignItems: 'center',      // Выравнивание по вертикали
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', // Тень
        fontFamily: 'sans-serif',
        fontSize: '18px',
        margin: '20px auto',       // Отступы вокруг контейнера
    };

    const banner = {
        display: 'flex',
        justifyContent: 'center',
        padding: '9px 6px 9px 6px',
        backgroundColor: '#E9510E',
        color: '#FFFFFF',
        fontWeight: 'bold',
        fontSize: '50%',
        alignItems: 'center',
        size: '50%',
        width: '30%',
        left: '25%',
        placeItems: 'center',
        //textAlign: 'center',
        //position: 'absolute',
    }

    return (
        <h1>
            <div style={{
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh', // Required for vertical centering in the viewport
                border: '2px solid black',

                position: 'relative',
                display: 'table',

                //width: '800px',

                marginBottom: '3px',
                marginLeft: 'auto',
                marginRight: 'auto',
                padding: '0px 0px 0px 0px',

                borderWidth: '2px',
                borderColor: '#212738',
                borderStyle: 'solid',

                backgroundColor: '#FFFFFF',

                textAlign: 'center',
            }}>
                <div>
                    <div style={{
                        padding: '10px',
                        height: '180px',
                        width: '100%',

                        backgroundColor: '#F5F6F7',

                        position: 'relative',
                        float: 'left',
                    }}>
                        <div>
                            <span style={{
                                margin: '15px 0px 0px 50px',
                                textAlign: 'center',
                                left: '25%',
                                position: 'absolute',
                                fontSize: '80%',
                                fontWeight: 'bold',

                                marginTop: '1.5em'
                            }}>Табу Тату Бот</span>
                        </div>
                    </div>
                    <div style={banner}>
                        <p>Добро пожаловать</p>
                    </div>
                </div>
                <div style={{
                    padding: '4px 8px 4px 8px',
                    color: '#000000',
                    fontSize: '100%',
                }}>
                    <p>
                        Привет. Я будущий функционал бота. В скором времени появится возможность
                        создавать опросы через моё веб-приложение. Ожидайте :3
                    </p>
                </div>
            </div>
        </h1>
    );
}